export default class LanguageSpecificWelcomeMessage {
  language = "";
  welcomeMessage = "";
}
